

define(['angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-models/src/address/index'], function (angular, squid, template) {

    return squid.module('xo-add-card.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address']).directive('xoAddCardFlow', function () {
        return {
            template: template,

            scope: {
                token: '=',
                parentCallbacks: '=',
                message: '=',
                pagetitle: '=',
                sidebar: '=',
                showmeftsection: '=',
                hideparenthead: '=',
                promotion: '=',
                pageLevel: '=',
                logout: '=',
                phone: '=',
                fundingid: '=',
                onSuccess: '=',
                backUri: '='
            },

            controller: function controller($scope, $state, $populate, $AddCardModel, $CardModel, $CheckoutSessionModel, $PrefillAddressModel, $util, $renderContent) {

                $scope.addCCDone = function () {
                    $scope.parentCallbacks.finish();
                };

                $scope.callbacks = {
                    done: function done() {
                        $scope.parentCallbacks.finish();
                    },

                    showCep: function showCep() {
                        $scope.prefillAddress = new $PrefillAddressModel({
                            id: $scope.token
                        });

                        $state.go('^.addCep');
                    },

                    cardTypeSelected: function cardTypeSelected(type) {
                        $scope.selectedPromotionCardType = {
                            type: type
                        };
                        $state.go('^.addCard');
                    }
                };

                $scope.cepDone = function () {
                    $state.go('^.addBilling');
                };

                $scope.selectedPromotionCardType = {
                    type: $scope.promotion && $scope.promotion.type
                };

                if ($scope.promotion) {
                    $scope.promotion.type = null;
                }

                $scope.billingaddressupdated = {
                    value: false
                };

                $scope.phone = {
                    hide_type: true
                };

                $scope.cardmodel = new $AddCardModel({
                    card: new $CardModel()
                });

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                        contingencies: {
                            NEED_CREDIT_CARD: angular.noop,
                            EXPIRED_CREDIT_CARD: angular.noop
                        }
                    })
                }).then(function () {

                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
                        var card = $scope.checkoutSession.errorData.resolution.data;

                        if (card.fundingId && card.fi && card.fi.type) {
                            $scope.cardmodel.id = card.fundingId;
                            $scope.cardmodel.card = new $CardModel({
                                number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                type: card.fi.type.toUpperCase(),
                                productType: card.fi.productType
                            });
                        }
                    }
                    if ($scope.fundingid) {
                        var fundingSource = $util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
                            if (funding && funding.id === $scope.fundingid) {
                                return funding;
                            }
                        });

                        if (fundingSource) {
                            $scope.cardmodel.id = fundingSource.id;
                            $scope.cardmodel.card = new $CardModel({
                                number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
                                lastDigits: fundingSource.lastDigits,
                                type: fundingSource.name,
                                name: $renderContent('fsMappings.' + fundingSource.name)
                            });
                        }
                    }
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/directive.js
// module id = ./components/xo-wallet-components/src/add-card/directive.js
// module chunks = 1